import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'antera-lib-kanban-container',
  templateUrl: './kanban-container.component.html',
  styleUrls: ['./kanban-container.component.scss']
})
export class KanbanContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
